import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteReviewItem } from 'src/app/models/review';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ReviewManagementService } from 'src/app/services/review-management.service';

@Component({
  selector: 'app-delete-reviews',
  templateUrl: './delete-reviews.component.html',
  styleUrls: ['./delete-reviews.component.css']
})
export class DeleteReviewsComponent implements OnInit {

  deleteReviews: DeleteReviewItem = new DeleteReviewItem()
  Loader: boolean = false;
  ReviewId: number;
  constructor(private _reviewDeleteService: ReviewManagementService, private modalService: NgbModal,private alertify: AlertifyService) { }

  ngOnInit() {
    this.ReviewId = this.ReviewId;
  }

  deleteReview() {
    this.Loader = true;
    this.deleteReviews.Id = this.ReviewId
    this._reviewDeleteService.deleteReview(this.deleteReviews)
    .subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.alertify.success(responseBody.responseMessage);
        this.modalService.dismissAll();
        this.Loader = false;
      } else {
        this.Loader = false
      }
    })
  }

  onCancel() {
    this.modalService.dismissAll();
  }
}
